import { Injectable } from '@angular/core';
import {
  SIMILAR_PATIENT_QUERY_BODY,
  SIMILAR_PATIENT_URL,
  SEARCH_SIMILAR_PATIENTS_URL
} from '@ispm-client/modules/similar-patients/services/config';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';
import { Observable } from 'rxjs';
import { ISimilarPatient } from '@ispm-client/modules/similar-patients/models/similar-patient.interface';

@Injectable()
export class SimilarPatientService {

  constructor(private ispmHttpClient: IspmHttpClient) {
  }

  getSimilarPatientById(patientId: string): Observable<ISimilarPatient> {
    return this.ispmHttpClient.post(SIMILAR_PATIENT_URL, SIMILAR_PATIENT_QUERY_BODY(patientId));
  }

  searchSimilarPatients(searchParams: any) {
    return this.ispmHttpClient.post(SEARCH_SIMILAR_PATIENTS_URL, searchParams);
  }

}

